import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/About.css';

const About = () => {
  useScrollAnimation();

  const values = [
    {
      title: '혁신',
      description: '끊임없는 기술 혁신을 통해\n더 나은 미래를 만들어갑니다.',
    },
    {
      title: '신뢰',
      description: '고객과의 신뢰를 바탕으로\n지속 가능한 파트너십을 구축합니다.',
    },
    {
      title: '전문성',
      description: '각 분야의 전문가들이 모여\n최고의 솔루션을 제공합니다.',
    },
  ];

  const history = [
    {
      year: '2025',
      month: '09',
      content: '경기도 AI 멤버십 기업(G-AIX) 선정',
    },
    {
      year: '2024',
      month: '11',
      content: '벤처기업 선정',
    },
    {
      year: '2024',
      month: '06',
      content: '기업부설연구소 선정',
    },
    {
      year: '2024',
      month: '',
      content: '말벌 퇴치 시스템 객체 인식 및 추적 알고리즘 적용',
    },
    {
      year: '2022',
      month: '',
      content: '수익과 재미가 있는 인터렉티브한 돼지 농장 표준 메타버스 시스템',
    },
    {
      year: '2021',
      month: '02',
      content: 'ZFlow 회사 설립',
    },
  ];

  const team = [
    {
      name: '대표자 경영철학 및 경영목표',
      description: (
        <>
          <strong>
            제트플로우는 [상생]을 핵심 가치로 삼고, 기술과 혁신을 통해 지속 가능한 미래를 만들어가고 있습니다.
          </strong>
          <br />
          빠르게 변화하는 IT 환경 속에서 제트플로우는 고객, 파트너, 그리고 사회와 함께 성장하는 기업을 지향합니다.
          지속적인 기술 혁신과 상호 협력을 통해 더 나은 내일을 만들어가는 것을 경영의 핵심 목표로 삼고 있습니다. 당사는
          4차 산업혁명과 인공지능, 메타버스 등 최신 기술을 융합한 혁신적인 플랫폼을 개발하여 고객 맞춤형 서비스를
          제공하고 있습니다. 특히 돼지 축산 산업에 특화된 가상현실 기반 원스톱 생태계를 구축함으로써, 현실과 디지털이
          연결된 새로운 산업 환경을 조성하고 있으며, 투자자와 사용자가 함께 성장할 수 있는 상생 구조를 실현해가고
          있습니다.
          <br />
          제트플로우는 지속 가능한 기술 혁신을 통해 글로벌 시장에서 경쟁력 있는 IT 기업으로 성장해 나갈 것입니다.
        </>
      ),
    },
  ];

  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <h2 className="about-section-title fade-in" id="about-intro">
          회사 소개
        </h2>

        <div className="about-vision-section fade-in" id="about-vision">
          <p className="about-vision-text">"AI 기술로 미래를 혁신하는 글로벌 리더"</p>
          <p className="about-vision-text">
            스마트팜 기술과 AI 솔루션으로 지속 가능한 농축산업을 실현하며,
            <br />
            카메라 기반 인공지능 분야의 선도 기업으로서, 지속적인 연구개발을 통해 혁신적인 솔루션을 제공합니다.
          </p>
        </div>

        <h2 className="about-section-title" id="about-values">
          핵심 가치
        </h2>
        <div className="about-values-grid">
          {values.map((value, index) => (
            <div key={index} className="about-value-card slide-in-up">
              <h3>{value.title}</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{value.description}</p>
            </div>
          ))}
        </div>

        <div className="about-history-section" id="about-history">
          <h2 className="about-section-title">연혁</h2>
          <div className="about-timeline">
            {history.map((item, index) => (
              <div key={index} className={`about-timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
                <div className={`about-timeline-content ${index % 2 === 0 ? 'left' : 'right'} fade-in`}>
                  <div className="year">{item.year}</div>
                  {item.month && <div className="month">{item.month}월</div>}
                  <div className="content">{item.content}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="about-team-section" id="about-team">
          <h2 className="about-section-title">경영진 소개</h2>
          {team.map((member, index) => (
            <div key={index} className="about-team-member fade-in">
              <div className="member-info">
                <div className="name-title">
                  <h4>{member.name}</h4>
                </div>
                <p className="description">{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
